import axios from "axios";
import { Speciality } from "./../../services/speciality";

export const state = {
  specialities: [],
  mostRequested: []
};

export const mutations = {
  SET_SPECIALITIES(state, specialities) {
    specialities.filter(c => {
      c.text = c.name;
      c.value = c.id;
    });

    state.specialities = specialities;
  },
  SET_MOST_REQUESTED(state, specialities) {
    state.mostRequested = specialities;
  }
};

export const getters = {
  specialities(state) {
    return state.specialities;
  },
  specialitiesOptions(state) {
    return state.specialities.map(specialty => ({
      label: specialty.name,
      value: specialty.id
    }));
  }
};

export const actions = {
  fetchAllSpecialities({ commit }) {
    return Speciality.all()
      .then(response => {
        commit("SET_SPECIALITIES", response.data);
        return response;
      })
      .catch(errors => errors);
  },
  fetchMostRequestedSpecialities({ commit }) {
    return Speciality.mostRequested()
      .then(response => {
        commit("SET_MOST_REQUESTED", response.data);
        return response;
      })
      .catch(errors => errors);
  }
};
